import React, { useMemo } from "react";
import { Modal, Typography, Tag, Empty } from "antd";
import moment from "moment";
import ModuleBreakdownPanels from "../ModuleBreakdownPanels";

const { Text } = Typography;

const fmtDateTime = (val) => (val ? moment(val).format("DD/MM/YYYY HH:mm") : null);

export default function MergeAuditDetailModal({ visible, onClose, record }) {
  const auditData = useMemo(() => {
    if (!record?.auditData) return null;
    if (typeof record.auditData === "string") {
      try {
        return JSON.parse(record.auditData);
      } catch {
        return null;
      }
    }
    return record.auditData;
  }, [record]);

  const fromSnap = auditData?.fromCustomer;

  return (
    <Modal
      title={
        <span style={{ color: "#ffffff", fontWeight: 600, fontSize: "16px" }}>
          Merged Details
        </span>
      }
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={540}
      wrapClassName="merge-audit-detail-modal"
      bodyStyle={{
        padding: "20px 24px",
        backgroundColor: "#ffffff",
        minHeight: "300px",
        maxHeight: "78vh",
        overflowY: "auto",
      }}
    >
      {!auditData ? (
        <Empty description="Audit data not available for this record" />
      ) : (
        <>
          {/* Subheader */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 16,
              paddingBottom: 10,
              borderBottom: "2px solid #e2e8f0",
            }}
          >
            <Text style={{ fontSize: 14, fontWeight: 600, color: "#2d3748" }}>
              Records transferred from &quot;{fromSnap?.name || "Customer"}&quot;
            </Text>
          </div>

          {/* Module Breakdown */}
          <ModuleBreakdownPanels snapshot={fromSnap} isLiveData={false} />
        </>
      )}
    </Modal>
  );
}
